import { v4 as uuidv4 } from "uuid";
export class PMOTeamListModel {
    constructor() {
        this.id = uuidv4();
        this.clientId = uuidv4();
        this.name = "";
    }
}
export default class PMOTeamList extends PMOTeamListModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
